import { AsyncTypeahead } from "react-bootstrap-typeahead";
import { createRef, useContext, useEffect, useState } from "react";
import { ApiTableColumn } from "../../../types/ApiTable/ApiTableColumn";
import { TableContext } from "../Context/TableContext";
import { Form } from "react-bootstrap";
import Typeahead from "react-bootstrap-typeahead/types/core/Typeahead";

interface FilterTypeaheadProps {
  column: ApiTableColumn;
}

const FilterTypeahead = ({ column }: FilterTypeaheadProps) => {
  const {
    state: { filters },
    updateFilter,
    clearFilter,
  } = useContext(TableContext)!;
  const [currentFilterValue, setCurrentFilterValue] = useState(
    filters?.find((f) => f.field === column.field),
  );
  const ref = createRef<Typeahead>();

  const {
    optionLabelKey: labelKey,
    optionValueKey,
    onSearch,
  } = column.filter!.typeaheadOptions!;

  const [options, setOptions] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const search = (searchTerm: string) => {
    setLoading(true);
    onSearch(searchTerm)
      .then((data) => {
        setOptions(data);
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false);
      });
  };

  const getFilterServiceText = (column: ApiTableColumn, value: string) => {
    return `${column.filter!.filterKey ?? column.field} eq ${value}`;
  };

  const onChange = (selected: any[]) => {
    if (selected.length > 0) {
      const value =
        selected[0][optionValueKey ?? column.filter!.filterKey ?? column.field];
      const label =
        typeof labelKey === "function"
          ? labelKey(selected[0])
          : selected[0][labelKey];
      const filter = {
        field: column.field,
        filterText: `${column.label} = ${label}`,
        value: selected[0],
        filterServiceText: getFilterServiceText(column, value),
      };
      updateFilter(filter);
      setCurrentFilterValue(filter);
    }
  };

  const onClear = (input: string) => {
    if (!input) {
      setOptions([]);
      clearFilter(column.field);
      setCurrentFilterValue(undefined);
    }
  };

  useEffect(() => {
    const thisFilter = filters?.find((f) => f.field === column.field);
    if (!thisFilter) {
      ref.current?.clear();
    }
    setCurrentFilterValue(thisFilter);
  }, [filters, column]);

  return (
    <Form.Group className="w-100">
      {column.filter?.label && (
        <Form.Label className="mb-0">{column.filter?.label}</Form.Label>
      )}
      <AsyncTypeahead
        ref={ref}
        className="w-100"
        id="filter-typeahead"
        isLoading={loading}
        onSearch={search}
        labelKey={labelKey}
        clearButton
        selected={
          currentFilterValue?.value ? [currentFilterValue.value] : undefined
        }
        options={options}
        onChange={onChange}
        placeholder={`Type to search ${column.label.toLowerCase()}`}
        onInputChange={onClear}
      />
    </Form.Group>
  );
};

export default FilterTypeahead;
